import { z } from 'zod';
/** Selling facts copied from the saved quote, never re-priced against today's catalogue. */
const signed = z.number().finite().min(-1e9).max(1e9);
export const ProposalQuoteSource = z.object({
    quote_id: z.string().min(1).max(160), label: z.string().max(300), source_hash: z.string().regex(/^[a-f0-9]{64}$/),
    primary: z.boolean(), recorded_at: z.string(),
    subtotal: signed, gst: signed, total: signed,
    lines: z.array(z.object({ id: z.string().max(160), tier: z.number().int().min(1).max(3),
        name: z.string().max(300), colour: z.string().max(160).nullable(), area: z.string().max(300),
        product_id: z.string().max(160).nullable(), variant_id: z.string().max(160).nullable(),
        quantity: signed, unit: z.string().max(30), unit_sell: signed.nullable(), line_sell: signed.nullable(),
    })).max(500),
});
//# sourceMappingURL=proposal-quote-source.js.map